"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colormixer_ts_1 = require("./colormixer.ts");
/**
 * This class represents the gamecontroller
 */
class GameController {
    constructor(game) {
        this.game = game;
        // Moves and mixes tiles if neighborhood is correct
        this.moveTiles = () => {
            this.infotext.text = "";
            if (this.game.input.activePointer.worldX < 129 && this.game.input.activePointer.worldY < 129) {
                let x = this.layer.getTileX(this.game.input.activePointer.worldX);
                let y = this.layer.getTileY(this.game.input.activePointer.worldY);
                if (!this.startTile) {
                    this.startTile = this.map.getTile(x, y, this.layer);
                    if (this.startTile.index > 7) {
                        this.startTile = null;
                        console.log("Wrong Move: Start tile is black or grey");
                        this.infotext.text = "Wrong Move: Start tile is black or grey!";
                        return;
                    }
                }
                else {
                    this.targetTile = this.map.getTile(x, y, this.layer);
                    if (this.targetTile.index > 7) {
                        console.log("Wrong Move: Target tile is black or grey");
                        this.infotext.text = "Wrong Move: Target tile is black or grey!";
                        this.targetTile = null;
                        return;
                    }
                    if (this.isNeighbor(this.startTile, this.targetTile)) {
                        let color = colormixer_ts_1.mixColors(this.startTile.index, this.targetTile.index);
                        this.map.replace(this.targetTile.index, color, x, y, 1, 1);
                        this.map.replace(this.startTile.index, 9, this.startTile.x, this.startTile.y, 1, 1);
                        console.log("color: ", color, "level: ", this.level);
                        switch (this.level) {
                            case 1:
                            case 3:
                                if (color === colormixer_ts_1.Color.RED) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 2:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 4:
                                if (color === colormixer_ts_1.Color.RED && !this.winCount.indexOf(colormixer_ts_1.Color.RED)) {
                                    this.winCount.push(colormixer_ts_1.Color.RED);
                                }
                                if (color === colormixer_ts_1.Color.YELLOW && !this.winCount.indexOf(colormixer_ts_1.Color.YELLOW)) {
                                    this.winCount.push(colormixer_ts_1.Color.YELLOW);
                                }
                                if (color === colormixer_ts_1.Color.BLUE && !this.winCount.indexOf(colormixer_ts_1.Color.BLUE)) {
                                    this.winCount.push(colormixer_ts_1.Color.BLUE);
                                }
                                if (this.winCount.length === 3) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 2:
                            case 5:
                                if (color === colormixer_ts_1.Color.BLUE) {
                                    this.winCount.push(colormixer_ts_1.Color.BLUE);
                                }
                                if (this.winCount.length === 2) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 8:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLUE);
                                }
                                if (this.winCount.length === 3) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 9:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLACK);
                                }
                                if (this.winCount.length === 3) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 10:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLACK);
                                }
                                if (this.winCount.length === 5) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 11:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLACK);
                                }
                                if (this.winCount.length === 4) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 12:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLACK);
                                }
                                if (this.winCount.length === 4) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 13:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLACK);
                                }
                                if (this.winCount.length === 3) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 6:
                                if (color === colormixer_ts_1.Color.GREEN) {
                                    this.winCount.push(colormixer_ts_1.Color.GREEN);
                                }
                                if (this.winCount.length === 2) {
                                    this.done[this.level] = true;
                                }
                                break;
                            case 7:
                                if (color === colormixer_ts_1.Color.BLACK) {
                                    this.winCount.push(colormixer_ts_1.Color.BLACK);
                                }
                                if (this.winCount.length === 2) {
                                    this.done[this.level] = true;
                                }
                                break;
                        }
                    }
                    this.targetTile, this.startTile = null;
                    if (this.done[this.level]) {
                        this.infotext.text = "Level complete!";
                    }
                }
            }
        };
        this.infotext = this.game.add.text(30, 195, '', { fill: '#ff0000' });
        this.done = Array(14);
        this.winCount = [];
        this.startTile, this.targetTile = null;
    }
    // Initialises the gamefield, the marker and the callbacks
    init(map) {
        this.map = this.game.add.tilemap(map);
        this.map.addTilesetImage('tiles');
        this.layer = this.map.createLayer('Tile Layer 1');
        this.layer.resizeWorld();
        this.marker = this.game.add.graphics();
        this.marker.lineStyle(2, 0xffffff, 1);
        this.marker.drawRect(0, 0, 32, 32);
        this.game.input.addMoveCallback(this.updateMarker, this);
        this.game.input.onDown.add(this.moveTiles, this);
    }
    // Updates the position of the marker
    updateMarker() {
        if (this.game.input.activePointer.worldX < 129 && this.game.input.activePointer.worldY < 129) {
            this.marker.x = this.layer.getTileX(this.game.input.activePointer.worldX) * 32;
            this.marker.y = this.layer.getTileY(this.game.input.activePointer.worldY) * 32;
            this.marker.visible = true;
        }
        else {
            this.marker.visible = false;
        }
    }
    // Checks if target tile lies in 4-connectivity neighborhood of start tile
    isNeighbor(start, target) {
        if (start.y + 1 === target.y && start.x === target.x)
            return true;
        if (start.y - 1 === target.y && start.x === target.x)
            return true;
        if (start.y === target.y && start.x - 1 === target.x)
            return true;
        if (start.y === target.y && start.x + 1 === target.x)
            return true;
        console.log("Wrong Move: No Neighbor selected");
        this.infotext.text = "Wrong Move: No Neighbor selected!";
        return false;
    }
}
exports.GameController = GameController;



//////////////////
// WEBPACK FOOTER
// ./src/gamecontroller.ts
// module id = 4
// module chunks = 0